import React from 'react';
import SelectWithIndeterminate from '../../../common/SelectWithIndeterminate';
import ToolTip from '../../../common/tooltip';
import withMinuteOptions, { minuteOptionShape } from '../../../common/hoc/withMinuteOptions';
import { t } from '../../../../modules/infra/i18n';

const BarberBookingInterval = ({ minuteOptionsNoZero }) => (
  <div className="layout__item">
    <div>
      <span className="c-label-new">{t('barber:booking_interval.barber_label')}</span>
      <div className="u-visible-inline-block-for-medium-and-up">
        <ToolTip
          text={t('barber:booking_interval.barber_tooltip')}
        />
      </div>
    </div>
    <SelectWithIndeterminate
      name="bookingInterval"
      className="c-select c-select--small u-mb u-1/4 u-1/5-extralarge-and-up u-mv0"
      suffix={t('barber:booking_interval.mins_suffix')}
      options={minuteOptionsNoZero.map(time => ({
        value: time,
        label: `${time} ${t('barber:booking_interval.mins')}`,
      }))}
      valueField="value"
      textField="label"
      empty
    />
  </div>
);

BarberBookingInterval.propTypes = {
  minuteOptionsNoZero: minuteOptionShape.isRequired,
};

export default withMinuteOptions(BarberBookingInterval);
